module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M3 0v16l12.571-8z\" stroke=\"none\"></path></svg>"